import { Route, Routes } from "react-router-dom";
import {
  AccountCreated,
  AccountRequested,
  AccountSelect,
  CompanyData,
  ComplementaryData,
  CreateAccount,
  CreatePassword,
  Forgot,
  InitialData,
  Login,
  NewPassword,
  SalesChannels,
  SignUp,
  UserData,
  UserWithAccount,
  VerifyEmail
} from "components/views/Account";
import { AppContainer } from "components/template";

const AccountRoutes = () => {  

  return(
    <AppContainer
      alignItems="center"
      justifyContent="center"
    >
      <Routes>
        <Route path="requested" element={<AccountRequested />} />
        <Route path="created" element={<AccountCreated />} />
        <Route path="select" element={<AccountSelect />} />
        <Route path="companyData" element={<CompanyData />} />
        <Route path="complementaryData" element={<ComplementaryData />} />
        <Route path="create" element={<CreateAccount />} />
        <Route path="createPassword" element={<CreatePassword />} />
        <Route path="initialData" element={<InitialData />} />
        <Route path="login" element={<Login />} />
        <Route path="forgot" element={<Forgot />} />
        <Route path="newPassword/:token" element={<NewPassword />} />
        <Route path="salesChannels" element={<SalesChannels />} />
        <Route path="signUp" element={<SignUp />} />
        <Route path="userData" element={<UserData />} />
        <Route path="verifyEmail" element={<VerifyEmail />} />
        <Route path="userWithAccount" element={<UserWithAccount />} />
        <Route path="*" element={<>Not found account path</>} />
      </Routes>
    </AppContainer>
  );
};

export default AccountRoutes;
